import { ICropping, sum } from "../omnia"
import { INutritionCalcService } from "../services/calcService"
import { INutritionPlan, INutritionPlanProductApp, INutritionService, NvzPlanCropping } from "../types"
import { sortApplicationDates } from "../utils"
import { getFieldLimit } from "./closedPeriodProvider"
import { INVZMessages } from "./types"

export class FieldLimitControlService {

    private calcSvc: INutritionCalcService;

    constructor(private svc: INutritionService) {
        this.calcSvc = svc.calculationService;
    }

    checkFieldsLimit(model: INutritionPlan, crops: NvzPlanCropping[]): INVZMessages {

        const planId = model.NutritionPlanId ?? 0

        const messages: INVZMessages = {
            error: false,
            canContinue: true,
            messages: []
        };

        var applicationsIds = model.Applications.map(a => a.NutritionPlanProductAppId);

        // Skip Field limit if fertilisers
        if (model.Applications &&
            model.Applications.length &&
            !model.Applications[0].ManureId &&
            !model.Applications[0].Manure) {
            return messages;
        }

        crops.forEach(c => {

            if (!c.cropping.Field.NVZ) {
                return;
            }

            var triggered = false;

            var applications = model.Applications.filter(a => !!a.ApplicationDate)
                .sort((a1, a2) => sortApplicationDates(a1, a2));

            for (var i = 0; i < applications.length && !triggered; i++) {

                const a = applications[i];

                var fieldLimit = getFieldLimit(a, c.cropping, this.svc.holding)

                var minDate = a.ApplicationDate;
                var maxDate = new Date(new Date(a.ApplicationDate.getTime()).setFullYear(a.ApplicationDate.getFullYear() - fieldLimit.yearCount));

                // Amount of N before the actual plan
                var initAmount = this.getNFromPrevCrops(planId, c.cropping, applicationsIds, [], minDate, maxDate);

                // Amount of N for this application and the others before (in the plan)
                var apps = applications.filter(app => app.ApplicationDate <= a.ApplicationDate)

                var currentAmount = this.calcSvc.calculateNTotalProvided(c.planRequirements.crop, apps, c.cropping);

                var amountPerHa = initAmount.amount + initAmount.prevAmount + currentAmount;

                if (amountPerHa > fieldLimit.maxRate) {


                    triggered = true;

                    // if (c.croppingId == 1756) {
                    // 	const details = {
                    // 		croppingId: c.croppingId,
                    // 		samePlanApps: apps.map(a => ({ planId: a.NutritionPlanId, appId: a.NutritionPlanProductAppId, date: a.ApplicationDate })),
                    // 		currentAmount,
                    // 		amount: initAmount,
                    // 		total: amountPerHa
                    // 	}
                    // 	console.log("FieldLimitControlService", details)
                    // }

                    messages.messages.push({
                        croppingId: c.cropping.CroppingId,
                        description: "The field limit of N is reached for this field (actual: " + Math.round(amountPerHa) + " kg, max: " + Math.round(fieldLimit.maxRate) + " kg). You cannot add more.",
                        application: a
                    });


                }
            }

        });

        if (messages.messages.length > 0) {
            messages.error = true;
            messages.canContinue = false;
        }

        return messages;

    }

    getNFromPrevCrops(planId: number, cropping: ICropping, applicationsIds: number[], excludedCroppingIds: number[], minDate: Date, maxDate: Date): { amount: number, prevAmount: number } {

        if (excludedCroppingIds.indexOf(cropping.CroppingId) !== -1) {
            return { amount: 0, prevAmount: 0 };
        }

        excludedCroppingIds.push(cropping.CroppingId);

        let currentAmount = this.getTotalNForPlanAndCropping(planId, cropping.CroppingId, minDate, maxDate);

        const prev = cropping.PreviousCroppings || []

        const prevN = prev.length > 0
            ? prev.map(c => this.getNFromPrevCrops(planId, c, applicationsIds, excludedCroppingIds, minDate, maxDate))
            : [];

        const result = {
            amount: currentAmount,
            prevAmount: (prevN.length > 0 ? (sum(prevN, p => p.amount) / prevN.length) + sum(prevN, p => p.prevAmount) : 0)
        }

        return {
            amount: result.amount || 0,
            prevAmount: result.prevAmount || 0
        }

    }

    /**
     * Returns the total N for a plan and a cropping, inside a range of dates
     */
    getTotalNForPlanAndCropping(planId: number, croppingId: number, minDate: Date, maxDate: Date): number {

        const apps = this.svc.getManureApplications(a =>
            (a.CroppingId == croppingId)
            && (a.PlanId != planId)
            && (a.ApplicationDate < minDate)
            && (a.ApplicationDate > maxDate)
        )

        if (apps.length > 0) {
            return sum(apps, a => a.NTotal);
        }

        return 0;

    }

    getNLeftFieldsLimit(model: INutritionPlan, cropping: NvzPlanCropping, application: INutritionPlanProductApp): number {

        const planId = model.NutritionPlanId ?? 0

        var applicationsIds = model.Applications.map(a => a.NutritionPlanProductAppId);

        if (!cropping.cropping.Field.NVZ) {
            return -1;
        }

        var fieldLimit = getFieldLimit(application, cropping.cropping, this.svc.holding)

        var minDate = application.ApplicationDate;
        var maxDate = new Date(new Date(application.ApplicationDate.getTime()).setFullYear(application.ApplicationDate.getFullYear() - fieldLimit.yearCount));

        // Amount of N before the current plan
        var initAmount = this.getNFromPrevCrops(planId, cropping.cropping, applicationsIds, [], minDate, maxDate);

        // Amount of N for the others before (in the plan)
        var apps = model.Applications.filter(app => app.ApplicationDate < application.ApplicationDate &&
            !!app.Manure && app !== application);
        var currentAmount = this.calcSvc.calculateNTotalProvided(cropping.planRequirements.crop, apps, cropping.cropping);

        var amountPerHa = initAmount.amount + initAmount.prevAmount + currentAmount;

        var left = fieldLimit.maxRate - amountPerHa;
        return left < 0 ? 0 : left;
    }
}
